import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageHeadingComponent } from '@bookinglab/govbook-ui/layout';
import { ApiService } from '../../services/jrni/api.service';
import { AppConfig } from '../../app.config';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import { JourneyService } from '../../services/journey.service';
import { DatastoreService } from '../../services';

@Component({
	selector: 'app-landing',
	standalone: true,
	imports: [CommonModule, PageHeadingComponent],
	templateUrl: './landing.component.html',
	styleUrl: './landing.component.scss',
})
export class LandingComponent implements OnInit {
	selectedDepartment: any;
	pageContent: any;
	pageHeader: string;

	constructor(
		private apiService: ApiService,
		private spinner: NgxSpinnerService,
		private router: Router,
		private route: ActivatedRoute,
		private datastoreService: DatastoreService
	) { }

	async ngOnInit(): Promise<void> {
		this.spinner.show();

		this.route.params.subscribe(async (params) => {
			let param = params['journey'];

			if (param == "citizenship") {
				this.datastoreService.updateCitizenship(true);
				this.datastoreService.isCitizenshipRoute = true;
				this.apiService.setCitizenshipToken();
			}

			let configCompanyId = AppConfig.settings.core.company_id;
			if (this.datastoreService.isCitizenshipRoute) {
				configCompanyId = AppConfig.settings.core.citizenship_company_id;
			}

			const _config: any = await this.apiService.getConfig(
				configCompanyId
			);

			this.datastoreService.journeyRoute = param;

			console.log('Journey parameter: ', param);
			// if no param, make it "default"
			if (!param) {
				param = 'default';
			}

			const content =
				_config?.journey_config?.appointments?.page_content?.[param];
			console.log(_config);

			if (_config.journey_config?.appointments?.disable_logs) {
				// eslint-disable-next-line @typescript-eslint/no-empty-function
				console.log = () => { };
			}

			if (content) {
				sessionStorage.setItem('journey', param);
				this.pageContent = content;
				this.datastoreService.pageContent = content;
			} else {
				console.log('No config found for journey: ', param);
				this.router.navigate(['/departments']);
			}
		});

		this.spinner.hide();
	}

	startJourney() {
		this.router.navigate(['/departments']);
	}
}
